import { Stack, Switch, Typography } from "@mui/material";
import React from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { isShowSerieLabel } from "../../../../viewer/chart/style/serie/isShowSerieLabel.ts";
import { isShowSerieLabelConnector } from "../../../../viewer/chart/style/serie/isShowSerieLabelConnector.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings, SeriesSettings } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  serie: SeriesSettings;
  readonlyMode: boolean;
}

export default function ShowLabelConnectorItem({ settings, serie, readonlyMode }: Props) {
  const showConnector = React.useMemo(() => isShowSerieLabelConnector(serie.name, settings), [settings, serie]);
  const disabled = React.useMemo(
    () => !isShowSerieLabel(serie.name, settings) || readonlyMode,
    [serie, settings, readonlyMode]
  );
  const dispatch = useAppDispatch();

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: `${disabled ? "text.disabled" : "text.secondary"}` }}>Show Label Connector</Typography>
      <HorizontalFill />
      <Switch
        checked={showConnector}
        disabled={disabled}
        onChange={(_, value) =>
          dispatch(fieldsStateActions.updateSeriesSettings({ name: serie.name, changes: { showConnector: value } }))
        }
      />
    </Stack>
  );
}
